import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_growth-eleven11/artifacts/bn2zsn8f_IMG_3514%20%281%29.PNG";

// Calendly popup function
const openCalendly = (e) => {
  e.preventDefault();
  if (window.Calendly) {
    window.Calendly.initPopupWidget({
      url: 'https://calendly.com/studioeleven380/30min'
    });
  }
};

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header 
        data-testid="main-header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'glass py-4' : 'bg-transparent py-6'
        }`}
      >
        <div className="container-custom flex items-center justify-between">
          {/* Logo */}
          <Link to="/" data-testid="header-logo" className="relative z-10">
            <img 
              src={LOGO_URL} 
              alt="Eleven11 Studios" 
              className="h-10 md:h-12 w-auto invert"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`nav-link text-sm font-medium transition-colors ${
                  isActive(link.path) ? 'text-[#F5F5F7]' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <button
            onClick={openCalendly}
            data-testid="header-cta-button"
            className="hidden lg:flex btn-primary text-sm"
          >
            Book a Consultation
            <ArrowRight className="w-4 h-4" />
          </button>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden relative z-10 p-2 text-[#F5F5F7]"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div 
        data-testid="mobile-menu"
        className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}
      >
        <nav className="flex flex-col items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
              className={`text-2xl font-medium transition-colors ${
                isActive(link.path) ? 'text-[#D4AF37]' : 'text-[#F5F5F7] hover:text-[#D4AF37]'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <button
            onClick={openCalendly}
            data-testid="mobile-cta-button"
            className="btn-primary mt-4"
          >
            Book a Consultation
            <ArrowRight className="w-4 h-4" />
          </button>
        </nav>
      </div>
    </>
  );
};

export default Header;
